import { MinusCircleOutlined, PlusOutlined } from "@ant-design/icons";
import { Button, Form, Select, Input } from "antd";

const { Option } = Select;
const { TextArea } = Input;

export const CODING_LANGUAGES = ["C++", "Java", "Python"];

/**
 * A shared component for managing multiple code implementations.
 * Uses standard Ant Design styling to match the existing codebase.
 *
 * @param {Object} props
 * @param {string|Array} props.name - The name for the Form.List
 * @param {string} [props.label="Implementations"] - The label for the field list
 */
const CodeImplementationField = ({ name, label = "Implementations" }) => {
  return (
    <Form.Item label={label}>
      <Form.List name={name}>
        {(subFields, { add: addSub, remove: removeSub }) => (
          <>
            {subFields.map(({ key: subKey, name: subName, ...subRestField }) => (
              <div
                key={subKey}
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  gap: 8,
                  marginBottom: 8,
                  alignItems: "flex-start"
                }}
              >
                <Form.Item
                  {...subRestField}
                  name={[subName, "language"]}
                  rules={[{ required: true, message: "Missing language" }]}
                  style={{ width: 150, maxWidth: "100%" }}
                >
                  <Select placeholder="Language">
                    {CODING_LANGUAGES.map((lang) => (
                      <Option key={lang} value={lang}>
                        {lang}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
                <Form.Item
                  {...subRestField}
                  name={[subName, "code"]}
                  rules={[{ required: true, message: "Missing code" }]}
                  style={{ width: 400, maxWidth: "100%" }}
                >
                  <TextArea placeholder="Code" autoSize={{ minRows: 2 }} />
                </Form.Item>
                <MinusCircleOutlined onClick={() => removeSub(subName)} />
              </div>
            ))}
            <Form.Item>
              <Button type="dashed" onClick={() => addSub()} block icon={<PlusOutlined />}>
                Add Implementation
              </Button>
            </Form.Item>
          </>
        )}
      </Form.List>
    </Form.Item>
  );
};

export default CodeImplementationField;
